export default __webpack_public_path__ + "static/media/pixel-moments-logo-white.ac402d95.svg";